import { render } from "./FormContact.vue?vue&type=template&id=15806e64&scoped=true"
import script from "./FormContact.vue?vue&type=script&lang=js"
export * from "./FormContact.vue?vue&type=script&lang=js"

import "./FormContact.vue?vue&type=style&index=0&id=15806e64&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15806e64"]])

export default __exports__